import { render, staticRenderFns } from "./ChatPreview.vue?vue&type=template&id=490527ec&"
import script from "./ChatPreview.vue?vue&type=script&lang=js&"
export * from "./ChatPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports